import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'card-del-applies';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

// 驳回退卡申请
export function update(id) {
  return patch({
    url: `${url}/${id}`,
  });
}

// 撤回退卡申请
export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
